import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar-empty-image',
  templateUrl: './sidebar-empty-image.component.html',
  styleUrls: ['./sidebar-empty-image.component.scss']
})
export class SidebarEmptyImageComponent implements OnInit {
  @Input() type: string;

  constructor() {}

  ngOnInit() {}
}
